
const isSSR = typeof window === "undefined";
const loadingModule = import('/Users/csr/workspace/console-components/packages/component/src/components/cascader/demo/demo3.js?loadDemo').catch(reason => {
// 服务端渲染的时候，忽略异步引入的模块中的错误（可能是因为使用了window对象）
if (isSSR) return;
throw reason;
});
export default loadingModule;
